const NAME = "NINE_BOX_CLASSIFICATION_PAGE";

export default NAME;
